export enum WebsocketEnums {
  notificationsChannelName = 'App.Models.User.',
}
